<form nz-form [formGroup]="searchForm" class="mb-3">
  <div class="flex items-center gap-3 flex-wrap">
    <div>
      <nz-range-picker
        [(ngModel)]="date"
        [ngModelOptions]="{ standalone: true }"
        [nzFormat]="dateFormat"
        (ngModelChange)="changeCalendar($event)"
      ></nz-range-picker>
    </div>
    <div>
      <nz-select
        formControlName="documentType"
        nzAllowClear
        nzPlaceHolder="{{ 'users.consent.documentType' | translate }}"
        style="min-width: 210px"
      >
        @for (opt of documentTypes; track opt.id) {
          <nz-option [nzValue]="opt.id" [nzLabel]="opt.name"></nz-option>
        }
      </nz-select>
    </div>
    <div>
      <nz-select
        formControlName="verified"
        nzAllowClear
        nzPlaceHolder="{{ 'users.consent.verified' | translate }}"
        style="min-width: 150px"
      >
        @for (opt of verifiedOptions; track opt.id) {
          <nz-option [nzValue]="opt.id" [nzLabel]="opt.name"></nz-option>
        }
      </nz-select>
    </div>
    <div>
      <button nz-button nzType="primary" (click)="search()">
        {{ 'users.consent.search' | translate }}
      </button>
    </div>
    <div>
      <button nz-button (click)="clearSearch()">
        {{ 'users.consent.clear' | translate }}
      </button>
    </div>
  </div>
</form>

<nz-table
  nzShowSizeChanger
  #nzTable
  [nzData]="loadData()"
  [nzFrontPagination]="false"
  [nzLoading]="loader()"
  [nzTotal]="total()"
  [nzPageSize]="pageSize()"
  [nzPageIndex]="page()"
  [nzVirtualForTrackBy]="trackByIndex"
  (nzQueryParams)="paginatorChange($event)"
  [nzPageSizeOptions]="[5, 10, 20, 50, 100]"
  nzSize="small"
  nzTableLayout="auto"
  [nzScroll]="{ x: '84vw' }"
>
  <thead>
    <tr>
      <th>{{ 'users.consent.column.type' | translate }}</th>
      <th>{{ 'users.consent.column.status' | translate }}</th>
      <th>{{ 'users.consent.column.code' | translate }}</th>
      <th>{{ 'users.consent.column.verified' | translate }}</th>
      <th>{{ 'users.consent.column.verifiedAt' | translate }}</th>
      <th>{{ 'users.consent.column.mobilePhone' | translate }}</th>
      <th>{{ 'users.consent.column.date' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    @for (row of loadData(); track row.id) {
      <tr>
        <td>
          <nz-tag>{{ 'users.consent.type.' + row.type | translate }}</nz-tag>
        </td>
        <td>{{ 'users.consent.status.' + row.status | translate }}</td>
        <td>{{ row.code || '—' }}</td>
        <td>{{ (row.verified ? 'users.consent.verifiedYes' : 'users.consent.verifiedNo') | translate }}</td>
        <td>{{ row.verifiedAt ? (row.verifiedAt | date: 'dd/MM/yyyy HH:mm') : '—' }}</td>
        <td>{{ row.mobilePhone || '—' }}</td>
        <td>{{ row.date | date: 'dd/MM/yyyy HH:mm' }}</td>
      </tr>
    }
  </tbody>
</nz-table>
